const validatePlateNumber = (value: string): boolean => {
  const cleanPlate = (value || '').replace(/\s+/g, '').toUpperCase();
  const plateRegex = /^[A-Z]{1,2}\d{1,4}[A-Z]{0,3}$/;
  return !plateRegex.test(cleanPlate);
};
export default validatePlateNumber;
